/*
  Theme vanilla module (Stage 4 of the OS 2.0 migration, Jul 2026).
  Replaces the jQuery-era bundles (app.min.js, vendor.aio, theme.aio, timber.aio):
  Bootstrap tabs and collapse, modals for popup_cart, the pro-qty spinner,
  product carousels (former slick) as scroll-snap
  with drag and arrows, #SortBy sorting, notification bar close, pagination
  and blog sidebar tweaks, and the timber.resetPasswordSuccess shim.
  app.min.css stays, so all Bootstrap class names keep their styling.
*/
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  /* ---------------- Bootstrap-style tabs ---------------- */
  document.addEventListener('click', function (e) {
    var link = closest(e.target, '[data-toggle="tab"]');
    if (!link) return;
    e.preventDefault();
    var targetSel = link.getAttribute('data-target') || link.getAttribute('href');
    if (!targetSel || targetSel.charAt(0) !== '#') return;
    var pane = document.querySelector(targetSel);
    if (!pane) return;

    var nav = closest(link, '.nav, ul');
    if (nav) {
      var actives = nav.querySelectorAll('.active');
      for (var i = 0; i < actives.length; i++) actives[i].classList.remove('active');
      link.classList.add('active');
      var li = closest(link, 'li');
      if (li) li.classList.add('active');
    }
    var content = pane.parentElement;
    if (content) {
      var panes = content.children;
      for (var j = 0; j < panes.length; j++) {
        panes[j].classList.remove('active', 'in', 'show');
      }
    }
    pane.classList.add('active', 'in', 'show');
  });

  /* ---------------- Bootstrap-style collapse ---------------- */
  document.addEventListener('click', function (e) {
    var trig = closest(e.target, '[data-toggle="collapse"]');
    if (!trig) return;
    e.preventDefault();
    var sel = trig.getAttribute('data-target') || trig.getAttribute('href');
    var box = sel ? document.querySelector(sel) : null;
    if (!box) return;
    var open = box.classList.contains('in') || box.classList.contains('show');
    box.classList.toggle('in', !open);
    box.classList.toggle('show', !open);
    trig.setAttribute('aria-expanded', String(!open));
    trig.classList.toggle('collapsed', open);
  });

  /* ---------------- Modals (popup_cart) ---------------- */
  var tpcModal = {
    show: function (id) {
      var m = typeof id === 'string' ? document.getElementById(id) : id;
      if (!m) return;
      m.classList.add('in', 'show');
      m.style.display = 'block';
      m.removeAttribute('aria-hidden');
      document.body.classList.add('modal-open');
      if (!document.querySelector('.modal-backdrop')) {
        var bd = document.createElement('div');
        bd.className = 'modal-backdrop fade in show';
        document.body.appendChild(bd);
      }
    },
    hide: function (id) {
      var m = typeof id === 'string' ? document.getElementById(id) : id;
      if (!m) return;
      m.classList.remove('in', 'show');
      m.style.display = 'none';
      m.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('modal-open');
      var bd = document.querySelector('.modal-backdrop');
      if (bd && bd.parentNode) bd.parentNode.removeChild(bd);
    },
    toggle: function (id) {
      var m = typeof id === 'string' ? document.getElementById(id) : id;
      if (!m) return;
      if (m.style.display === 'block') { tpcModal.hide(m); } else { tpcModal.show(m); }
    }
  };
  window.tpcModal = tpcModal;

  document.addEventListener('click', function (e) {
    var dis = closest(e.target, '[data-dismiss="modal"]');
    if (dis) { e.preventDefault(); tpcModal.hide(closest(dis, '.modal')); return; }
    if (e.target.classList && e.target.classList.contains('modal') && e.target.style.display === 'block') {
      tpcModal.hide(e.target);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.modal.show, .modal.in');
    if (open) tpcModal.hide(open);
  });

  /* ---------------- pro-qty spinner ----------------
     Markup replicates the original app.min.js plugin exactly:
     two appended <a> elements, classes inc/dec qty-btn, positioned by app.min.css. */
  function initQty() {
    var boxes = document.querySelectorAll('.pro-qty');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.getAttribute('data-qty-init')) continue;
      box.setAttribute('data-qty-init', '1');
      var inc = document.createElement('a');
      inc.href = '#';
      inc.className = 'inc qty-btn';
      inc.textContent = '+';
      var dec = document.createElement('a');
      dec.href = '#';
      dec.className = 'dec qty-btn';
      dec.textContent = '-';
      box.appendChild(inc);
      box.appendChild(dec);
    }
  }
  document.addEventListener('click', function (e) {
    var btn = closest(e.target, '.pro-qty .qty-btn');
    if (!btn) return;
    e.preventDefault();
    var input = closest(btn, '.pro-qty').querySelector('input');
    if (!input) return;
    var val = parseFloat(input.value) || 0;
    var next;
    if (btn.classList.contains('inc')) {
      next = val + 1;
    } else if (val > 0) {
      next = val - 1;
    } else {
      next = 0;
    }
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- product / brand carousels (former slick) ---------------- */
  function perViewFor(el, width) {
    var d = parseInt(el.getAttribute('data-per-view'), 10) || 4;
    var md = parseInt(el.getAttribute('data-per-view-md'), 10) || Math.min(d, 3);
    var sm = parseInt(el.getAttribute('data-per-view-sm'), 10) || 2;
    if (width < 480) return 1;
    if (width < 768) return sm;
    if (width < 992) return md;
    return d;
  }

  function layoutCarousel(el) {
    var per = perViewFor(el, window.innerWidth);
    var kids = el.children;
    for (var i = 0; i < kids.length; i++) {
      kids[i].style.flex = '0 0 ' + (100 / per) + '%';
      kids[i].style.maxWidth = (100 / per) + '%';
    }
    var wrap = el.parentElement;
    if (wrap) {
      var prev = wrap.querySelector('.tpc-car-prev');
      var next = wrap.querySelector('.tpc-car-next');
      var overflow = el.scrollWidth > el.clientWidth + 4;
      if (prev) prev.style.display = overflow ? '' : 'none';
      if (next) next.style.display = overflow ? '' : 'none';
    }
  }

  function initCarousels() {
    var els = document.querySelectorAll('[data-tpc-carousel]');
    for (var i = 0; i < els.length; i++) {
      (function (el) {
        if (el.getAttribute('data-car-init')) { layoutCarousel(el); return; }
        el.setAttribute('data-car-init', '1');
        el.classList.add('tpc-carousel');

        var wrap = el.parentElement;
        if (wrap) {
          wrap.classList.add('tpc-carousel-wrap');
          var prev = document.createElement('button');
          prev.type = 'button';
          prev.className = 'tpc-car-prev';
          prev.setAttribute('aria-label', 'Previous');
          prev.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          var next = document.createElement('button');
          next.type = 'button';
          next.className = 'tpc-car-next';
          next.setAttribute('aria-label', 'Next');
          next.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          wrap.appendChild(prev);
          wrap.appendChild(next);
          prev.addEventListener('click', function () { el.scrollBy({ left: -el.clientWidth, behavior: 'smooth' }); });
          next.addEventListener('click', function () { el.scrollBy({ left: el.clientWidth, behavior: 'smooth' }); });
        }

        /* drag to scroll with mouse, like slick allowed */
        var isDown = false, startX = 0, startLeft = 0, moved = false;
        el.addEventListener('mousedown', function (e) {
          isDown = true; moved = false;
          startX = e.pageX; startLeft = el.scrollLeft;
          el.classList.add('is-dragging');
        });
        window.addEventListener('mousemove', function (e) {
          if (!isDown) return;
          var dx = e.pageX - startX;
          if (Math.abs(dx) > 5) moved = true;
          el.scrollLeft = startLeft - dx;
        });
        window.addEventListener('mouseup', function () {
          isDown = false;
          el.classList.remove('is-dragging');
        });
        el.addEventListener('click', function (e) {
          if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
        }, true);

        layoutCarousel(el);
      })(els[i]);
    }
  }
  window.tpcInitCarousels = initCarousels;
  window.addEventListener('resize', function () {
    var els = document.querySelectorAll('[data-tpc-carousel]');
    for (var i = 0; i < els.length; i++) layoutCarousel(els[i]);
  });

  /* ---------------- collection sorting ---------------- */
  function initSort() {
    var sel = document.getElementById('SortBy');
    if (!sel || sel.getAttribute('data-sort-init')) return;
    sel.setAttribute('data-sort-init', '1');
    sel.addEventListener('change', function () {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        window.location.href = url.toString();
      } catch (e) {
        window.location.search = 'sort_by=' + encodeURIComponent(sel.value);
      }
    });
  }

  /* ---------------- small ports ---------------- */
  function initMisc() {
    var dead = document.querySelectorAll('.theme-default-pagination .disabled a, .theme-default-pagination li.active a, .sidebar-widget li.active a');
    for (var i = 0; i < dead.length; i++) dead[i].removeAttribute('href');
  }
  document.addEventListener('click', function (e) {
    var sub = closest(e.target, '.category-sub-menu li.has-sub > a');
    if (sub) {
      sub.removeAttribute('href');
      var li = closest(sub, 'li');
      if (li) li.classList.toggle('open');
    }
  });

  /* ---------------- timber shim (customer reset password) ---------------- */
  window.timber = window.timber || {};
  if (typeof window.timber.resetPasswordSuccess !== 'function') {
    window.timber.resetPasswordSuccess = function () {
      var el = document.getElementById('ResetSuccess');
      if (el) { el.classList.remove('hide'); el.style.display = 'block'; }
    };
  }

  ready(function () {
    initQty();
    initCarousels();
    initSort();
    initMisc();
  });
})();
